import React from 'react';
import { Star } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { reviews } from '../data/mock';

const Reviews = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Cosa dicono i nostri clienti
          </h2>
          <p className="text-lg text-gray-600">
            La soddisfazione dei clienti è la nostra priorità
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {reviews.map((review) => (
            <Card
              key={review.id}
              className="border-2 border-gray-100 hover:shadow-lg transition-all duration-300"
            >
              <CardContent className="pt-6">
                <div className="flex gap-1 mb-4">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star
                      key={i}
                      className="h-5 w-5 fill-orange-500 text-orange-500"
                    />
                  ))}
                </div>
                
                <p className="text-gray-700 mb-4 italic">
                  "{review.text}"
                </p>
                
                <div className="border-t pt-4">
                  <p className="font-semibold text-gray-900">{review.name}</p>
                  <p className="text-sm text-gray-600">{review.location}, Roma</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
